/**
 * This file contains empty functions.
 * If `() => {}` is use normally in code, eslint will underline them show them as error. (Unexpected empty arrow function  no-empty-function)
 * due to ESLint rule of `no-empty-function`.
 * We can do the following to stop the eslint error:
 * #1: Disabled the error by add "// eslint-disable-next-line @typescript-eslint/no-empty-function"
 * #2: OR add comment inside function (eslint allow because comment is considered documentation of intent)
 */

/**
 * @description No operation aka Empty function.
 *
 * @returns {void}
 */
export const noOp = (): void => {
  // do nothing
};

/**
 * @description No operation aka Empty async function.
 *
 * @returns {Promise<void>}
 */
export const asyncNoOp = (): Promise<void> => {
  // do nothing
  return Promise.resolve();
};
